import { ApolloProvider } from "@apollo/client";
import { apolloClient } from "apolloClient";
import { appHistory } from "appHistory";
import { Role } from "generated/graphql";
import React from "react";
import { Router, Switch } from "react-router-dom";
import { AdminDashboardPage } from "Views/AdminDashboard/AdminDashboard";
import { ApplicationDetailsPage } from "Views/ApplicationDetails/ApplicationDetailsPage";
import {
  ApproveOrDenyPurchasePage,
  PurchaseApprovedPage,
  PurchaseDeniedPage,
} from "Views/ApproveOrDenyPurchasePage";
import { ChangePasswordPage } from "Views/ChangePasswordPage";
import { CreateNewPasswordPage } from "Views/CreateNewPassword";
import {
  AdminRoute,
  AuthenticatedRoute,
  PublicRoute,
} from "Views/CustomRoutes";
import { ErrorPage } from "Views/ErrorPage";
import { ForgotPasswordPage } from "Views/ForgotPasswordPage";
import { getLcpRoutes } from "Views/LcpWorkflow/getLcpRoutes";
import { LogInPage } from "Views/LogInPage";
import { ManageAccountsPage } from "Views/ManageAccountsPage/ManageAccountsPage";
import { NotFoundPage } from "Views/NotFoundPage";
import { AdminPaths, PublicPaths } from "Views/Paths";
import { SearchResultsPage } from "Views/SearchResults";
import "./App.scss";

function getAdminRoutes() {
  return [
    <AdminRoute exact path={AdminPaths.AdminDashboard} key="adminDashboard">
      <AdminDashboardPage />
    </AdminRoute>,
    <AdminRoute exact path={"/SearchResults"} key="searchResults">
      <SearchResultsPage />
    </AdminRoute>,
    <AdminRoute
      exact
      path={AdminPaths.ManageAccounts}
      roles={[Role.SUPER_ADMIN]}
      key="manageAccounts"
    >
      <ManageAccountsPage />
    </AdminRoute>,
    <AdminRoute
      exact
      path={AdminPaths.ApplicationDetails({ app: { id: ":id" } })}
      key="applicationDetails"
    >
      <ApplicationDetailsPage />
    </AdminRoute>,
    <AdminRoute
      exact
      path={AdminPaths.ApproveOrDenyPurchase({
        adminApprovalKey: ":adminApprovalKey",
      })}
      key="approveOrDenyPurchase"
    >
      <ApproveOrDenyPurchasePage />
    </AdminRoute>,
    <AdminRoute
      exact
      path={AdminPaths.PurchaseApproved({
        adminApprovalKey: ":adminApprovalKey",
      })}
      key="purchaseApproved"
    >
      <PurchaseApprovedPage />
    </AdminRoute>,
    <AdminRoute
      exact
      path={AdminPaths.PurchaseDenied({
        adminApprovalKey: ":adminApprovalKey",
      })}
      key="purchaseDenied"
    >
      <PurchaseDeniedPage />
    </AdminRoute>,
  ];
}

function getUserRoutes() {
  return [
    <PublicRoute exact path={PublicPaths.LogIn} key="logIn">
      <LogInPage />
    </PublicRoute>,
    <PublicRoute exact path={PublicPaths.ForgotPassword} key="forgotPassword">
      <ForgotPasswordPage />
    </PublicRoute>,
    <PublicRoute
      exact
      path={PublicPaths.CreateNewPassword}
      key="createNewPassword"
    >
      <CreateNewPasswordPage />
    </PublicRoute>,

    <AuthenticatedRoute
      exact
      path={PublicPaths.ChangePassword}
      key="changePassword"
    >
      <ChangePasswordPage />
    </AuthenticatedRoute>,
  ];
}

function getRoutes() {
  return [
    ...getAdminRoutes(),
    <PublicRoute exact path={PublicPaths.Error} key="error">
      <ErrorPage />
    </PublicRoute>,
    ...getUserRoutes(),
    ...getLcpRoutes(),
    <PublicRoute key="notFound">
      <NotFoundPage />
    </PublicRoute>,
  ];
}

export function App() {
  return (
    <ApolloProvider client={apolloClient}>
      <Router history={appHistory}>
        <Switch children={getRoutes()} />
      </Router>
    </ApolloProvider>
  );
}
